module.exports = __webpack_public_path__ + "img/ellipse__two.19efabce.png";